import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { IntermediaryFee } from '@api/btlApplicationForm/types';
import { intermediaryFeesQuestions } from '@pages/ApplicationFormPage/IntermediaryFees/questions';
import { useIntl } from 'react-intl';
import { formatCurrency } from './caseSummaryFormatters';

interface IntermediaryFeesReadOnlyTableProps {
  fees: IntermediaryFee[];
}

export function IntermediaryFeesReadOnlyTable({ fees }: IntermediaryFeesReadOnlyTableProps) {
  const { formatMessage } = useIntl();

  const columns: ColumnsType<IntermediaryFee> = [
    {
      title: formatMessage({ id: intermediaryFeesQuestions.fees.description.labelKey }),
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: formatMessage({ id: intermediaryFeesQuestions.fees.amount.labelKey }),
      dataIndex: 'amount',
      key: 'amount',
      render: (amount: number) => formatCurrency(amount),
    },
    {
      title: formatMessage({ id: intermediaryFeesQuestions.fees.whenPayable.labelKey }),
      dataIndex: 'whenPayable',
      key: 'whenPayable',
    },
    {
      title: formatMessage({ id: intermediaryFeesQuestions.fees.howPayable.labelKey }),
      dataIndex: 'howPayable',
      key: 'howPayable',
    },
    {
      title: formatMessage({ id: intermediaryFeesQuestions.fees.refundableAmount.labelKey }),
      dataIndex: 'refundableAmount',
      key: 'refundableAmount',
      render: (refundableAmount: number) => formatCurrency(refundableAmount),
    },
  ];

  return <Table columns={columns} dataSource={fees} pagination={false} rowKey='id' size='middle' className='mt-4' />;
}
